import React from "react";

function Barras({ itens, rotuloDe, maxRotulos }) {
  const maximo = Math.max(1, ...itens.map((i) => i.pedidos));
  const pico = itens.findIndex((i) => i.pedidos === maximo && maximo > 0);
  return (
    <div>
      <div className="flex items-end gap-1 h-20">
        {itens.map((it, i) => (
          <div key={i} className="flex-1 h-full flex items-end" title={`${rotuloDe(it)}: ${it.pedidos} pedido(s)`}>
            <div className={`w-full rounded-t ${i === pico ? "bg-primary" : "bg-primary/35"}`} style={{ height: `${(it.pedidos / maximo) * 100}%`, minHeight: it.pedidos ? 2 : 0 }} />
          </div>
        ))}
      </div>
      <div className="flex gap-1 mt-1">
        {itens.map((it, i) => (
          <span key={i} className="flex-1 text-center text-[9px] text-muted-foreground tabular-nums">
            {!maxRotulos || i % maxRotulos === 0 ? rotuloDe(it) : ""}
          </span>
        ))}
      </div>
    </div>
  );
}

export default function SemanaHora({ semana, hora, titulo = "Quando mais usam" }) {
  const total = (semana || []).reduce((s, d) => s + d.pedidos, 0);
  const melhorDia = total ? semana.reduce((a, b) => (b.pedidos > a.pedidos ? b : a)) : null;
  const melhorHora = total ? hora.reduce((a, b) => (b.pedidos > a.pedidos ? b : a)) : null;
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5" data-e2e="semana-hora">
      <h3 className="font-semibold">{titulo}</h3>
      <p className="text-xs text-muted-foreground mb-3">
        {total ? <>Mais pedidos às <b className="text-foreground">{melhorDia.dia}</b>, por volta das <b className="text-foreground">{melhorHora.hora}h</b>.</> : "Sem pedidos no período."}
      </p>
      <div className="grid sm:grid-cols-2 gap-5">
        <Barras itens={semana || []} rotuloDe={(d) => d.dia} />
        <Barras itens={hora || []} rotuloDe={(h) => `${h.hora}h`} maxRotulos={4} />
      </div>
    </section>
  );
}
